<template>
  <div class="about-page page-container">
    <div class="content">
      <div class="menus-wrap">
        <div class="menu" v-for="menu in menus" :class="{ activated: activated === menu.key }" :key="menu.key" @click="onClickMenu(menu)">
          {{ menu.label }}
        </div>
      </div>
      <div class="left-bl">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [],
      richTextList: {}, //富文本
      activated: '',
    };
  },
  activated() {
    this.initMenu();
    this.selectMenu(this.$route.path);
  },
  watch: {
    $route(to) {
      this.selectMenu(to.path);
    },
  },
  methods: {
    selectMenu(path) {
      if (this.allMenus) {
        for (const menu of this.allMenus) {
          if (path.includes(`/${menu.key}`)) {
            if (menu.isMore !== this.menus[0].isMore) {
              this.initMenu();
            }
            this.activated = menu.key;
            setTimeout(() => {
              this.initScrollTop();
            }, 50);
            break;
          }
        }
      }
    },
    initMenu() {
      this.type = this.$route.query.type || '';
      this.allMenus = [
        { label: '关于一席', key: 'aboutYiXi' },
        { label: '商务合作', key: 'businessCooperation' },
        { label: '版权说明', key: 'copyright' },
        { label: '用户协议', value: 0, key: 'userAgreement', isMore: true },
        { label: '隐私条款', value: 1, key: 'privacy', isMore: true },
        { label: '会员手册', value: 2, key: 'memberHandbook', isMore: true },
		{ label: '自动续费服务规则', value: 3, key: 'continuityvip', isMore: true },
      ];
      this.menus = this.allMenus.filter(menu => {
        if (this.type === 'more') {
          return menu.isMore;
        }
        return !menu.isMore;
      });
    },
    onClickMenu(menu) {
      this.activated = menu.key;
      this.$router.push({
        path: `/About/${menu.key}`,
        query: {
          type: menu.isMore ? 'more' : '',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.about-page {
  padding-top: 20px;
}
.content {
  margin-top: 20px;
  max-width: 1070px;
  display: flex;
  align-items: flex-start;
  .menus-wrap {
    width: 250px;
    flex-shrink: 0;
    background-color: $C1;
    .menu {
      position: relative;
      font-size: 24px;
      text-align: center;
      height: 70px;
      line-height: 70px;
      color: $C6;
      cursor: pointer;
      font-weight: bold;
      &:hover {
        background: $C2;
        color: $C1 !important;
        transition: all 0.3s ease;
        font-weight: bold;
      }
      &.activated {
        font-weight: bold;
        color: $C7;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 100%;
          width: 4px;
          background: $C2;
        }
      }
    }
  }
  .left-bl {
    flex: 1;
    margin-left: 10px;
    min-width: 0;
    background-color: $C1;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  }
}
</style>
